<template>
    <!-- 总平台管理－场地管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'sitePages')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="场地名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="场地电话">
                        <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="所在城市">
                        <a-select allowClear placeholder="请选择" v-decorator="['city']" @select="search">
                            <a-select-option :value="item" v-for="item in cityList" :key="item">{{item}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="门店状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['state']" @select="search">
                            <a-select-option value="1">正常营业</a-select-option>
                            <a-select-option value="0">停止营业</a-select-option>
                            <a-select-option value="2">即将开业</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <template slot="extra">
                    <a-button v-if="getBtnByAuth('addBranchStore')" type="primary" @click="toAddStore()">新增场地</a-button>
                    <a-button v-if="getBtnByAuth('batchSetBusinessHours')" type="primary" @click="toSpecialBusinessSet()">特殊营业时间设置</a-button>
                </template>
                <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                >
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="state" slot-scope="a,row">{{['停止营业','正常营业','即将开业'][row.state]}}</span>
                <span slot="action" slot-scope="a,row">
                    <a v-if="getBtnByAuth('updateBranchStore')" class="text-primary" @click="toUpdateStore(row.id)">编辑</a>
                    
                    <a v-if="getBtnByAuth('detailBranchStore')" class="text-primary" @click="toDetailStore(row.id)"><a-divider type="vertical"/>详情</a>
                    
                    <a v-if="getBtnByAuth('orderInventory')" class="text-primary" @click="orderInventory(row.id)"><a-divider type="vertical"/>预约库存</a>

                    <a v-if="getBtnByAuth('album')" class="text-primary" @click="toStoredPhoto(row.id)"><a-divider type="vertical"/>门店相册</a>

                    <a v-if="getBtnByAuth('businessHoursManage')" class="text-primary" @click="toSpecialBusiness(row)"><a-divider type="vertical"/>特殊营业时间</a>
                </span>
                </a-table>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "sitePages",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "序号",
                key: "index",
                scopedSlots: { customRender: "index" }
            },
            {
                title: "场地名称",
                dataIndex: "name"
            },
            {
                title: "场地地址",
                dataIndex: "address"
            },
            {
                title: "场地电话",
                dataIndex: "phone"
            },
            {
                title: "状态",
                dataIndex: "state",
                scopedSlots: { customRender: "state" }
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
            ];
            return {
                cityList: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                }
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getCityList() {
                this.$api.totalPlatform.cityList().then(res => {
                    this.cityList = res;
                });
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.shopId;
                    this.$api.totalPlatform.getAllShopList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },
            orderInventory(id) {
                this.$router.push({
                    name: "orderInventory",
                    params: { id: id }
                });
            },

            // 跳转至新增页
            toAddStore() {
                this.$router.push({
                    name: "addBranchStore",
                });
            },
            // 跳转至特殊营业时间设置页
            toSpecialBusinessSet() {
                this.$router.push({
                    name: "specialBusinessSet",
                    query: { id: this.shopId, shopName: sessionStorage.getItem('currentShopName')}
                });
            },
            // 跳转至特殊营业时间页
            toSpecialBusiness(row) {
                this.$router.push({
                    name: "specialBusiness",
                    query: { id: row.id, shopName: row.name}
                });
            },

            // 跳转至编辑
            toUpdateStore(id) {
                this.$router.push({
                    name: "updateBranchStore",
                    query: { id: id}
                });
            },

            // 跳转至详情
            toDetailStore(id) {
                this.$router.push({
                    name: "detailBranchStore",
                    query: { id: id}
                });
            },
            // 跳转至门店相册
            toStoredPhoto(id) {
                this.$router.push({
                    name: "storedPhoto",
                    params: { id: id }
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList()
            this.getCityList();
        },
        watch: {
            $route(val) {
                val.name == "sitePages" && this.getList();
            },
            'shopId'() {
                this.getList()
            }
        }
    };
</script>
<style lang="scss">
</style>